import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["data", "options"],
  watch: {
    data: function() {
      this.$data._chart.destroy();
      this.render();
    },
    options: function() {
      this.$data._chart.destroy();
      this.render();
    }
  },
  mounted() {
    this.render();
  },
  methods: {
    render: async function() {
      await this.renderChart(this.data, this.options);
      if (this.options.customLegendDisplay) {
        document.getElementById(
          "chart-legends"
        ).innerHTML = this.generateLegend();
      }
    }
  }
};
